<template>
  <div>
    <p class="has-text-weight-bold is-size-4 mb-1">
      {{ $t("mp:application.data_validation.title") }}
    </p>

    <application-template
      template="MERCHANT_APPLICATION_DATA_VALIDATION"
    ></application-template>
  </div>
</template>

<script>
export default {
  name: "ApplicationFlowDataValidation",
  components: {
    ApplicationTemplate: () =>
      import("@/components/application/ApplicationTemplate.vue"),
  },
};
</script>

<style scoped lang="scss"></style>
